// @flow
import React from 'react';
import {InlineLink} from 'sail/InlineLink';
import Group from 'sail/Group';
import {Text} from 'sail/Text';
import {defineMessages, FormattedMessage} from 'react-intl';

import {DownloadButton} from './DownloadButton';
import './IntroCallout.scss';

const messages = defineMessages({
  partners: {
    id: 'docsShell.integrationBuilder.guide.partners',
    description: 'Callout to go to the partners program page.',
    defaultMessage:
      "Don't code? Use Stripe’s <NoCodeLink>no-code options</NoCodeLink> or get help from <PartnersLink>our partners</PartnersLink>.",
  },
});

export const IntroCallout = () => (
  <Group
    className="IntroCallout"
    direction="horizontal"
    alignItems="center"
    spacing={12}
    wrap="wrap"
  >
    <DownloadButton />
    <Text color="gray">
      <FormattedMessage
        {...messages.partners}
        values={{
          PartnersLink: (text) => (
            <InlineLink href="/partners/apps-and-extensions" target="_blank">
              {text}
            </InlineLink>
          ),
          NoCodeLink: (text) => (
            <InlineLink href="/docs/payments/no-code" target="_blank">
              {text}
            </InlineLink>
          ),
        }}
      />
    </Text>
  </Group>
);
